<div class="unlogged-form-page login">
    <form class="box" [formGroup]="usernameFG" (ngSubmit)="showPassword()" *ngIf="showingPage === 'username'">
        <h1 class="page-title text">
            Garantor
        </h1>
        <h2 class="page-description text">
            Login
        </h2>
        <mat-form-field class="login-field garantor-form-field" appearance="outline">
            <mat-label>Ingresa tu usuario</mat-label>
            <input matInput type="text" formControlName="username" id="usernameInput" autocomplete="username" required>
            <mat-error *ngIf="usernameFG.controls['username'].hasError('required')">
                Por favor ingrese un usuario
            </mat-error>
        </mat-form-field>
        <div class="buttons-container">
            <button mat-button color="primary" class="next-button garantor-button mini" [disabled]="!usernameFG.valid">
                Siguiente
            </button>
        </div>
    </form>
    <form class="box password-box-animation" [formGroup]="passwordFG" (ngSubmit)="login()" *ngIf="showingPage === 'password'">
        <h1 class="page-title text">
            Garantor
        </h1>
        <h2 class="page-description text">
            Login
        </h2>
        <span class="login-error" *ngIf="error">{{ error }}</span>
        <mat-form-field class="login-field garantor-form-field" appearance="outline">
            <mat-label>Ingresa tu contraseña</mat-label>
            <input matInput type="password" formControlName="password" id="passwordInput" autocomplete="current-password" required>
            <mat-error *ngIf="passwordFG.controls['password'].hasError('required')">
                Por favor ingrese una contraseña
            </mat-error>
        </mat-form-field>
        <div class="buttons-container">
            <button mat-button class="back-button garantor-button mini" type="button" (click)="showUsername()">
                Volver
            </button>
            <button mat-button color="primary" class="login-button garantor-button mini" [disabled]="!passwordFG.valid">
                Iniciar sesión
            </button>
        </div>
    </form>
    <span class="version">v{{ environment.version }}</span>
    <re-captcha #captchaRef="reCaptcha" (resolved)="resolvedCaptcha($event)" [siteKey]="captchaKey" errorMode="handled" (error)="onRecaptchaError()" size="invisible" *ngIf="captchaKey"></re-captcha>
</div>
